import "./statusTag.scss"; // Import SCSS file
import { VeTypography } from "../../mui";

interface StatusTagProps {
  status?:
    | "pending"
    | "pending-variant"
    | "pdd"
    | "empty"
    | "failed"
    | "completed"
    | "requiresAction"
    | "approved"
    | "approved-variant"
    | "live"
    | "underVerification"
    | "escrow"
    | "draft"
    | "thumbNail"
    | "init"
    | "onHold"
    | "prePdd"
    | "danger"
    | "danger-variant"
    | "primaryUser"
    | "onHoldNoBorder"
    | "lightPending"
    | "blueTag"
    | "greenActive";
  children: React.ReactNode;
  className?: string;
  bullet?: boolean;
  sx?: any;
  noBorder?: boolean;
  onClick?: any;
  color?: string; // Custom color for border and text
  location?: boolean;
  textColor?: string;
}

export function StatusTag({
  status = "pending",
  children,
  className,
  bullet = true,
  sx,
  onClick = () => {},
  noBorder = false,
  color,
  location = false,
  textColor,
}: StatusTagProps) {
  let stickerClass = "sticker"; // Use class name directly

  if (status) {
    stickerClass += ` ${status}`;
  }

  // Custom styles when color is provided
  const customStyles = color
    ? {
        borderColor: color,
        color: color,
        ...sx,
      }
    : sx;

  return (
    <div
      className={`${stickerClass} ${className} ${noBorder && "noBorder"}`}
      style={customStyles}
      onClick={onClick}
    >
      {" "}
      {bullet && (
        <span
          className={`bullet ${status}Bullet`}
          style={color ? { backgroundColor: color } : undefined}
        />
      )}
      {location && <LocationSvg />}
      <VeTypography
        className="removeDefault"
        sx={{
          color: textColor ? textColor : undefined,
          fontSize: textColor ? "10px !important" : undefined,
        }}
      >
        {" "}
        {children}
      </VeTypography>
    </div>
  );
}

const LocationSvg = ({ color = "#2B6CB0" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
    >
      <path
        d="M3.5 4.75C3.16848 4.75 2.85054 4.6183 2.61612 4.38388C2.3817 4.14946 2.25 3.83152 2.25 3.5C2.25 3.16848 2.3817 2.85054 2.61612 2.61612C2.85054 2.3817 3.16848 2.25 3.5 2.25C3.83152 2.25 4.14946 2.3817 4.38388 2.61612C4.6183 2.85054 4.75 3.16848 4.75 3.5C4.75 3.66415 4.71767 3.8267 4.65485 3.97835C4.59203 4.13001 4.49996 4.26781 4.38388 4.38388C4.26781 4.49996 4.13001 4.59203 3.97835 4.65485C3.8267 4.71767 3.66415 4.75 3.5 4.75ZM3.5 0C2.57174 0 1.6815 0.368749 1.02513 1.02513C0.368749 1.6815 0 2.57174 0 3.5C0 6.125 3.5 10 3.5 10C3.5 10 7 6.125 7 3.5C7 2.57174 6.63125 1.6815 5.97487 1.02513C5.3185 0.368749 4.42826 0 3.5 0Z"
        fill={color}
      />
    </svg>
  );
};
